import { axios } from '@/utils/request'

export function collectionUserAccountList (parameter = {}) {
  return axios({
    url: '/collectionUserAccountInfo/collectionUserAccountList',
    method: 'post',
    data: parameter
  })
}

export function collectionUserAccountUpdate (parameter = {}) {
  return axios({
    url: '/collectionUserAccountInfo/collectionUserAccountUpdate',
    method: 'post',
    data: parameter
  })
}

export function collectionAccountTradeFlowList (parameter = {}) {
  return axios({
    url: '/collectionAccountTradeFlow/list',
    method: 'post',
    data: parameter
  })
}

export function repayCertWorkOrderList (parameter = {}) {
  return axios({
    url:'/repayCertWorkOrder/list',
    method: 'post',
    data: parameter
  })
}


export function updateRepayCertWorkOrder (data = {}) {
  return axios({
    url:'/repayCertWorkOrder/update',
    method: 'post',
    data
  })
}
export function updateRepayCertWorkOrder2 (data = {}) {
  return axios({
    url:'/repayCertWorkOrder/update2',
    method: 'post',
    data
  })
}

export function createPayOrder(data = {}) {
    return axios({
        url: 'repayCertWorkOrder/createPayOrder',
        method: 'post',
        data
    })
}
export function createPayOrderV2(data = {}) {
  return axios({
      url: '/order/createPayOrderV2',
      method: 'post',
      data
  })
}
export function getPartRepayChannel(data = {}) {
  return axios({
      url: '/order/getPartRepayChannel',
      method: 'post',
      data
  })
}
// webpublic/order/createPayOrderV2

export function baseData() {
  return axios({
    url: '/collectionUserAccountInfo/baseData',
    method: 'get'
  })
}

export function repeatRepayFlowList(parameter = {}) {
  return axios({
    url: '/repeatRepayFlow/list',
    method: 'post',
    data: parameter
  })
}

export function repeatRepayFlowUpdate(parameter = {}) {
  return axios({
    url: '/repeatRepayFlow/update',
    method: 'post',
    data: parameter
  })
}

export function repeatRepayFlowUpdateBatch(parameter = {}) {
  return axios({
    url: '/repeatRepayFlow/updateBatch',
    method: 'post',
    data: parameter
  })
}